<template>
    <div>
        <li v-for="formation in $props.formations">
            <div v-if="formation.hide_from_catalog && formation.external_link">
                <a :href="formation.external_link" target="_blank" rel="nofollow">
                    {{formation.name}}
                </a>
            </div>
            <div v-if="formation.hide_from_catalog && !formation.external_link">
                {{formation.name}}
            </div>
            <div v-if="!formation.hide_from_catalog">
                <a target="_blank" :href="formation.url">
                    {{formation.name}}
                </a>
            </div>
        </li>
    </div>
</template>

<script>
import UserType from "../../enums/UserType";
import {getters} from "../../store";

export default {
    props: ['formations'],
    computed:{
        userType: function () {
            return getters.user()?.type;
        }
    },
    methods: {
        open(formation) {
            if (this.userType === UserType.LEARNER) {
                this.$router.push({name: 'formations_view', params: {formationId: formation.id}});
                return;
            }

            this.$router.push({
                name: 'folders_formation',
                params: {folderId: this.folderId, formationId: formation.id}
            });
        }
    }
}
</script>
